import { render, staticRenderFns } from "./FactoryList.vue?vue&type=template&id=84733ccc&scoped=true&"
import script from "./FactoryList.vue?vue&type=script&lang=js&"
export * from "./FactoryList.vue?vue&type=script&lang=js&"
import style0 from "./FactoryList.vue?vue&type=style&index=0&id=84733ccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84733ccc",
  null
  
)

export default component.exports